// extracted by mini-css-extract-plugin
export default {"container":"inscription_container__dJMYC","content":"inscription_content__tYu9e","jsonValue":"inscription_jsonValue__47VOh","value":"inscription_value__iYEkI"};